import styled from "styled-components";

import { Title } from "@similarweb/ui-components";

export const StyledPageTitle: any = styled(Title)`
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: normal;
    width: 100%;
    max-width: 1368px;
`;
StyledPageTitle.displayName = "StyledPageTitle";
